export const DEBUG_NAMESPACE = 'strapi:core:openapi';
export const REGEX_STRAPI_PATH_PARAMS = /:([^/]+)/g;
